import { apiClient } from '@copro/api';
import { useQuery } from '@tanstack/react-query';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

async function fetchExpenseCategories(spaceId: string) {
  const { data, error } = await apiClient
    .from('expense_categories')
    .select('*')
    .eq('space_id', spaceId)
    .order('name');

  if (error) {
    throw error;
  }

  return data;
}

export function useGetExpenseCategories() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.categories(currentSpace?.id ?? ''),
    queryFn: () => fetchExpenseCategories(currentSpace!.id),
    enabled: !!currentSpace?.id,
  });
}
